module.exports = __webpack_public_path__ + "img/bulage-2.b90e32c6.jpg";